import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from './PermissionsContext';

// page — ключ раздела из pages.js. Без него маршрут проверяет только вход,
// как раньше (страницы вне каталога прав: /accessdenied и подобные).
const PrivateRoute = ({ element, page }) => {
    const isAuthenticated = localStorage.getItem('token');
    const { loading, can } = usePermissions();

    if (!isAuthenticated) return <Navigate to="/login" />;
    if (!page) return element;
    if (loading) return null;
    return can(page) ? element : <Navigate to="/accessdenied" replace />;
};

export default PrivateRoute;
